import Vue from 'vue'
import Vuex from 'vuex'
import resources from '@/resources'
import { SORT_BY_DATE } from '@/types'

Vue.use(Vuex)

export function createStore () {
    return new Vuex.Store({
        state: {
            code: null,
            projects: [],
            loading: [],
            errors: {
                projects: {
                    fetch: null,
                    create: null,
                    spend: null
                },
                code: {
                    fetch: null
                }
            },
            filters: {
                archived: false,
                sortBy: SORT_BY_DATE
            }
        },
        actions: {
            fetchProjects ({ commit }) {
                commit('addLoadingState', 'projects')
                commit('unsetResponseError', {key: 'projects', type: 'fetch'})
                return resources.get('projects')
                    .then(response => {
                        commit('removeLoadingState', 'projects')
                        commit('setProjects', response.data)
                        return response.data
                    })
                    .catch(error => {
                        commit('setResponseError', {key: 'projects', type: 'fetch', error: error.response.data || true})
                        commit('removeLoadingState', 'projects')
                        throw error
                    })
            },

            fetchCode ({ commit }, code) {
                commit('addLoadingState', 'codes')
                commit('unsetResponseError', {key: 'code', type: 'fetch'})
                return resources.get('codes/' + code)
                    .then(response => {
                        commit('removeLoadingState', 'code')
                        // check for hearts left (provider doesnt care for that x))
                        if (response.data.code.hearts_left > 0) {
                            return commit('setCode', response.data.code)
                        }
                        // TODO: This should happen on provider and give back error instead of 200
                        commit('setResponseError', {key: 'code', type: 'fetch', error: response.data})
                    })
                    .catch(error => {
                        commit('setResponseError', {key: 'code', type: 'fetch', error: error.response.data || true})
                        commit('removeLoadingState', 'code')
                        return error
                    })
            },

            createProject ({ commit }, project) {
                // POST: projects/
                commit('addLoadingState', 'create')
                commit('unsetResponseError', {key: 'projects', type: 'create'})

                return resources.post('projects', project, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(response => {
                        commit('removeLoadingState', 'create')
                        return response
                    })
                    .catch(error => {
                        commit('removeLoadingState', 'create')
                        commit('setResponseError', {key: 'projects', type: 'create', error: error.response.data || true})
                        return error.response
                    })
            },

            spendProject ({ commit }, {projectId, code, count}) {
                // POST: projects/{project}/heart/{code}/{qty}
                commit('addLoadingState', 'spend')
                commit('unsetResponseError', {key: 'projects', type: 'spend'})
                return resources.post(`projects/${projectId}/heart/${code}/${count}`)
                    .then(response => {
                        commit('removeLoadingState', 'spend')
                        commit('updateProject', response.data.project)

                        if (response.data.code.hearts_left > 0) {
                            return commit('setCode', response.data.code)
                        }

                        commit('unsetCode')
                    })
                    .catch(error => {
                        commit('setResponseError', {key: 'projects', type: 'spend', error: error.response.data || true})
                        commit('removeLoadingState', 'spend')
                        return error
                    })
            }
        },
        mutations: {
            setProjects (state, projects) {
                state.projects = projects
            },

            updateProject (state, updatedProject) {
                const project = state.projects.find(project => {
                    return project.id === updatedProject.id
                })
                // Update the project
                project.hearts_count = updatedProject.hearts_count
                project.hearts_left = updatedProject.hearts_left
            },

            setCode (state, code) {
                state.code = code
            },

            unsetCode (state) {
                state.code = null
            },

            addLoadingState (state, resourceName) {
                const loading = state.loading
                // Add resource name to loading array
                loading.push(resourceName)
                state.loading = loading
            },

            removeLoadingState (state, resourceName) {
                const index = state.loading.indexOf(resourceName)
                state.loading.splice(index, 1)
            },

            setResponseError (state, {key, type, error}) {
                state.errors[key][type] = error
            },

            unsetResponseError (state, {key, type}) {
                state.errors[key][type] = null
            },

            setFilters (state, filters) {
                state.filters = filters
            }
        },
        getters: {
            getLoadingState (state) {
                return resourceName => state.loading.indexOf(resourceName) > -1
            },

            getResponseError (state) {
                return ({key, type}) => state.errors[key][type]
            },

            getTotalDonationCount (state) {
                return Math.round(state.projects.reduce((total, project) => total + project.hearts_count / 2, 0))
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/store/index.js